import './App.scss';
import Crawler from './app/crawler/crawler';
import { Navigate, Route, Routes } from 'react-router-dom';
import JobDetail from './app/crawler/pages/jobDetail/jobDetail';
import UserContext, { UserContextInterface } from './app/contexts/user-context';
import { useEffect, useState } from 'react';
import { User } from './app/crawler/crawler.interface';
import { getAllCrawlfishUsers, getLoggedInUser } from './app/crawler/services/crawler.services';
import { PrivateRoute } from './app/utils/privateRoute';
import DomainLevelStatus from './app/crawler/pages/domainStatus/domainLevelStatus/domainLevelStatus';
import { _redirectToLogin } from './app/crawler/services/base.services';

declare global {
    interface Window {
        _env_: ImportMetaEnv;
    }
}

function App() {
    // If env vars are undefined, exit the app
    if (!import.meta.env.VITE_BASE_CF_URL || !import.meta.env.VITE_BASE_PL_URL) {
        return null;
    }
    // test
    const [userData, setUserData] = useState<UserContextInterface>({ user: {} as User, crawlfishUsers: [] as User[] });
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        getUser();
    }, []);

    async function getUser() {
        try {
            const currentUser = await getLoggedInUser();
            if (currentUser && currentUser.crawlfish_user) {
                const users = await getAllCrawlfishUsers(currentUser?.current_role);
                if (users && users.length > 0) {
                    users.sort((a, b) => a.username.localeCompare(b.username));
                }
                setIsLoading(false);
                setUserData({ user: currentUser, crawlfishUsers: users });
            } else {
                _redirectToLogin();
            }
        } catch (err) {
            console.error('Unable to get a logged in user. Redirecting to login page ...');
            setIsLoading(false);
            setTimeout(() => {
                _redirectToLogin();
            }, 2000);
        }
    }

    if (!isLoading && !userData?.user?.email) {
        return (
            <div className='error-page'>
                <main>
                    <div className='error-content'>
                        <h2>Oops</h2>
                        <p>Something went wrong fetching your user. Redirecting to login page ...</p>
                    </div>
                </main>
            </div>
        );
    }


    return (
        <UserContext.Provider value={{ user: userData.user, crawlfishUsers: userData.crawlfishUsers }}>
            {userData?.user?.email &&
                <Routes>
                    <Route path='jobs' element={
                        <PrivateRoute user={userData.user}>
                            <Crawler />
                        </PrivateRoute>
                    } />
                    <Route path='jobs/:id' element={
                        <PrivateRoute user={userData.user}>
                            <JobDetail />
                        </PrivateRoute>
                    } />
                    <Route path='domain-status/:id' element={
                        <PrivateRoute user={userData.user}>
                            <DomainLevelStatus />
                        </PrivateRoute>
                    } />
                    <Route path='' element={
                        <PrivateRoute user={userData.user}>
                            <Navigate to='jobs' replace />
                        </PrivateRoute>
                    } />
                </Routes>
            }
        </UserContext.Provider>
    );
}

export default App;
